import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faCreditCard, faMoneyBillTransfer, faBuildingColumns, faMoneyCheck } from '@fortawesome/free-solid-svg-icons';

library.add(faCreditCard as any, faMoneyBillTransfer as any, faBuildingColumns as any, faMoneyCheck as any);

// Debug environment variables
console.log('Environment Variables:');
console.log('REACT_APP_DEBUG_MODE:', process.env.REACT_APP_DEBUG_MODE);
console.log('REACT_APP_API_URL:', process.env.REACT_APP_API_URL);
console.log('REACT_APP_STORE_NAME:', process.env.REACT_APP_STORE_NAME);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
